 
<template>   
    <div class="modal fade" :id="modal" tabindex="-1" aria-hidden="true">  
        <div class="modal-dialog" style="max-width:1700px;">  
            <div class="modal-content" style="min-height: 500px;">  
                <div class="modal-header"> 
					<h2 v-if="dados"> {{ dados.id }} - {{ dados.nome }}</h2> 
					<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
						<span class="svg-icon svg-icon-1">
							<inline-svg src="media/icons/duotone/Navigation/Close.svg"/>
						</span>
					</div> 
				</div> 
				<div class="modal-body scroll-y m-5">
                    <div class="row g-6 g-xl-12">  
                        <CardRh :processando="processando" titulo="Aulas Externo" v-if="dados">  
                            <table class="table table-striped"  style="margin-top: 20px;">
                                <thead>
                                    <tr>  
                                        <th>#</th>
                                        <th>Id</th>
                                        <th>Número</th> 
                                        <th>Data</th> 
                                        <th>Início</th> 
                                        <th>Fim</th>  
                                        <th>Status</th> 
                                        <th>Controlador</th> 
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr  v-for="(p, index) in dados.aulasExterno" :key="p.id"> 
                                        <td>{{index +1}}</td>
                                        <td>{{p.id}}</td> 
                                        <td>{{p.numero}}</td> 
                                        <td>{{ SiteUtils.formatData( p.data ) }}</td> 
                                        <td>{{p.inicio}}</td> 
                                        <td>{{p.fim}}</td>  
                                        <td>{{p.status.nome}}</td> 
                                        <td>{{p.controladorId}}</td> 
                                    </tr> 
                                    <tr  v-if="dados.aulasExterno.length < 1 "  >
                                        <td colspan="8">nenhum item encontrado</td> 
                                    </tr> 
                                </tbody>
                            </table> 
                        </CardRh>   
                        <br>
                        <CardRh :processando="processando" titulo="Aulas Interno" v-if="dados">  
                            <table class="table table-striped"  style="margin-top: 20px;">
                                <thead>
                                    <tr>  
                                        <th>#</th>
                                        <th>Id</th>
                                        <th>Número</th> 
                                        <th>Data</th> 
                                        <th>Início</th> 
                                        <th>Fim</th>  
                                        <th>Status</th> 
                                        <th>Controlador</th> 
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr  v-for="(p, index) in dados.aulasInterno" :key="p.id"> 
                                        <td>{{index +1}}</td>
                                        <td>{{p.id}}</td> 
                                        <td>{{p.numero}}</td> 
                                        <td>{{ SiteUtils.formatData( p.data ) }}</td> 
                                        <td>{{p.inicio}}</td> 
                                        <td>{{p.fim}}</td>  
                                        <td>{{p.status.nome}}</td> 
                                        <td>{{p.controladorId}}</td> 
                                    </tr> 
                                    <tr  v-if="dados.aulasInterno.length < 1 "  >
                                        <td colspan="8">nenhum item encontrado</td> 
                                    </tr> 
                                </tbody>
                            </table> 
                        </CardRh>   
                    </div>  
				</div>   
			</div> 
		</div> 
	</div> 
</template>


<script lang="ts"> 
    import { Options   } from "vue-class-component";   
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import {  Vue  } from "vue-class-component";  
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    import {  Prop  , Watch } from 'vue-property-decorator';   
    import CardRh from   "@/components/cards/ManzaCard.vue"
    
    @Options({
        name: "RelatorioPagamentoInstrutorIndex",
        components: {  CardRh },  
        emits: [  'update-turma-alterado'],  
    }) 
    export default class RelatorioPagamentoInstrutorIndex  extends Vue {
        
        @Prop( ) readonly modal!: any 
        @Prop( ) readonly perfis!: any  
        @Prop( ) readonly service!: any
        @Prop( ) readonly cpf!: any
        @Prop( ) readonly dataAulaMin!: any
        @Prop( ) readonly dataAulaMax!: any

        public processando = false;  
        public dados: any  = null ;   
        public SiteUtils: any  = SiteUtils ;   
          
        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin , PerfilConfig.ChefeSTE , PerfilConfig.AuxSTE ] , this.perfis ); 
        }
 
        @Watch('cpf')
        public modeloAlterado(){  
            this.dados = null;
            if(this.cpf != null ){
                this.service.getRelatorioPagamentoInstrutor(this.cpf, this.dataAulaMin,this.dataAulaMax) 
                .then(response => {   
                    this.dados =  JSON.parse(JSON.stringify( response ));    
                })
                .catch(error => {
                    this.dados = null;  
                });  
            }
        } 
    } 
</script>

<style scoped> 
    .col-12{
        margin-bottom: 40px;
    } 
    .btn-flex{
        max-width: 90%;
        min-width: 90%;
    }
</style>